import { defineMessage, MessageDescriptor } from 'react-intl';

type VideoContent = {
  title: MessageDescriptor;
  id?: string;
  url?: string;
  alt: string;
};

type Video = Record<string, VideoContent>;
type Videos = Record<string, Video>;

const videos: Videos = {
  shopify$$teamleader: {
    'how-to': {
      title: defineMessage<MessageDescriptor>({
        id: 'shopify$$teamleader-video-title',
        defaultMessage: 'Sync your online sales with Teamleader',
      }),
      id: 'https://youtu.be/eDtoMJJsOkw',
      url: 'https://youtu.be/eDtoMJJsOkw',
      alt: 'Demo Teamleader-Shopify',
    },
    intro: {
      title: defineMessage<MessageDescriptor>({
        id: 'shopify$$teamleader-video-intro-title',
        defaultMessage: 'Sync your online sales with Teamleader',
      }),
      id: 'https://youtu.be/q6jS9jpLkv8',
      url: 'https://youtu.be/q6jS9jpLkv8',
      alt: 'Intro Teamleader-Shopify',
    },
  },
};

export default videos;
